﻿'use strict';

angular.module('ntmApp').factory('DataCollection', ['SetupService', 'ConfirmationService', 'FlashService', function (SetupService, ConfirmationService, FlashService) {

    function DataCollection() {

        var self = this;
        var record = {};
        var activityInEdit = {};
        var loggedData = [];

        self.dataLoaded = false;
        self.editMode = false;

        self.init = function (data) {
            if (!data.PK_RSACT_) {
                self.title = 'Data Collection Dialog';
                self.errorMsg = "Activity is not saved. Please, save activity first.";
                self.dataLoaded = true;
                return;
            }

            record = data;
            self.title = '{0} Data Collection Fields'.format(record.Activity_Name_);

            if (!self.collectionFields) {

                self.dataLoaded = false;

                SetupService.GetDataCollection(data.PK_RSACT_).then(function (result) {

                    self.collectionFields = result.data.jsonData ? JSON.parse(result.data.jsonData) : { active: [], deactivated: [] };

                    if (result.data.loggedData) {
                        loggedData = result.data.loggedData.map(d => JSON.parse(d));
                    }
                    
                    self.dataLoaded = true;
                });
            } else {
                self.dataLoaded = true;
                self.collectionFields = self.collectionFields || { active: [], deactivated: [] };
            }
        };

        self.addNewRecord = function () {
            self.collectionFields.active.push({
                id: getNextSequence('id'),
                name: "",
                required: false,
                sequence: getNextSequence('sequence'),
                edit: true
            });

            self.editMode = true;
            self.addNew = true;
        };

        self.edit = function (activity) {
            activityInEdit = angular.copy(activity);
            activity.edit = true;
            self.editMode = true;
        };

        self.cancel = function (activity) {
            if (self.addNew) {
                self.collectionFields.active.pop();
                self.addNew = false;
            }

            activity.name = activityInEdit.name;
            activity.sequence = activityInEdit.sequence;
            activity.required = activityInEdit.required;
            activity.edit = false;

            self.editMode = false;
        };

        self.save = function (activity) {
            var msg = null;

            if (activity) {
                msg = '{0} {1}'.format(activity.name, self.addNew ? 'added' : 'updated');
                delete activity.edit;
                delete activity.$$hashKey;
            } else {
                self.collectionFields.active.map(function (item) {
                    delete item.edit;
                    delete item.$$hashKey;

                    return item;
                });
            }

            refreshData(msg);
        };


        self.activate = function (activity, index) {
            var msg = '{0} reactivated'.format(activity.name);

            self.collectionFields.deactivated.splice(index, 1);
            self.collectionFields.active.push(activity);

            refreshData(msg);
        };

        self.deactivate = function (activity, index) {

            if (hasLoggedData(activity.id)) {
                deactivateActivity(activity, index);
            } else {

                var msg = '{0} does not have any historical data. Completely delete it from {1} instead (deletion cannot be undone)?'.format(activity.name, record.Activity_Name_);
                ConfirmationService.Confirmation(msg, null, { yes: 'Yes, delete', no: 'No, deactivate', cancel: 'Never mind', title: 'Alert' })
                    .Yes(function () {
                        var msg = '{0} deleted from {1} activity'.format(activity.name, record.Activity_Name_);

                        self.collectionFields.active.splice(index, 1);
                        refreshData(msg);
                    })
                    .No(function () {
                        deactivateActivity(activity, index);
                    })
                    .Ask();
            }
           
        };

        self.confirmExit = function (modalInstance) {
            ConfirmationService.Confirmation("Save pending changes?", null, { yes: 'Yes', no: 'No', cancel: 'Cancel' })
                .Yes(function () {
                    if (self.dataCollectionForm.$valid) {
                        self.save();
                        modalInstance.close(true);
                    } else {
                        FlashService.Error("Please, fill out all required fields");
                    }
                })
                .No(function () {
                    modalInstance.close(self.dataHasChanged);
                })
                .Ask();
        };

        self.saveData = function () {

            if (!record.PK_RSACT_) {
                return;
            }

            var strJson = JSON.stringify(self.collectionFields);
            var data = {
                id: record.PK_RSACT_,
                jsonData: strJson
            };

            SetupService.SaveDataCollection(data);
        };

        function getNextSequence(prop) {
            var sequence = 0;
            var mix = self.collectionFields.active.concat(self.collectionFields.deactivated);

            mix.forEach(function (item) {
                sequence = item[prop] > sequence ? item[prop] : sequence;
            });

            return sequence + 1;
        }

        function deactivateActivity(activity, index) {
            var msg = '{0} deactivated'.format(activity.name);

            self.collectionFields.active.splice(index, 1);
            activity.dateDeactivated = new Date();
            self.collectionFields.deactivated.push(activity);

            refreshData(msg);
        }

        function refreshData(msg) {
            var strJson = JSON.stringify(self.collectionFields);
            record.JSON_DCFRM_ = strJson;
            record.Data_Collection_Fields_ = getDataColectionString();
            if (record.dialogModel) {
                record.dialogModel.TXT_DCFRM = record.Data_Collection_Fields_;
            }
            displayMsg(msg);
            self.editMode = false;
            self.addNew = false;
            self.dataHasChanged = true;
        }

        function getDataColectionString() {
            return (self.collectionFields.active || []).map(f => f.name).join(',');
        }

        function displayMsg(msg) {
            self.successMessage = msg;
            setTimeout(function () {
                self.successMessage = null;
            }, 5000);
        }

        function hasLoggedData(id) {
            if (loggedData.length === 0) {
                return false;
            }

            return loggedData.filter(r => r.some(i => (i.id === id && i.value !== null))).length > 0;

        }
    }

    return (DataCollection);

}]);